import React, { useState, useEffect } from 'react';
import { AccountingPortal } from './AccountingPortal';

export const Accounting = () => {
  useEffect(() => {
    document.title = "Accounting Portal | CaseDB";
  }, []);

  return (
    <div className="page-container">
      <AccountingPortal />
    </div>
  );
};

export default Accounting;
